<template>
    <div>
        <el-row :gutter="10" v-if="!showAlert" style="z-index: 0" v-loading="loadingReport">
            <div class="toolbar">
                <el-row>
                    <el-col :span="24" :md="24" :sm="24" :xs="24" justify="end">
                        <template>
                            <el-select v-model="selectedMessageTypeField" placeholder="Message Type" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                v-for="item in messageTypeField"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- <el-select v-model="selectedSessionTypeField" placeholder="Session Status" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                v-for="item in sessionTypeField"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select> -->
                            <el-date-picker class="mr-5 mb-10"
                                style="top: 2px !important; width:220px;"
                                v-model="selectedStartDate"
                                range-separator="to"
                                size="mini"
                                type="daterange"
                                placeholder="Pick a day">
                            </el-date-picker>
                            <el-select v-model="selectedFilter" placeholder="Filter By" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                v-for="itm in filterBy"
                                :key="itm.value"
                                :label="itm.label"
                                :value="itm.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectedPhone" placeholder="Select Phone Number" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                v-for="item in number"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                            <el-select v-model="selectedField" placeholder="Select Field" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                <el-option
                                v-for="item in searchFields"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <el-input
                                style="width:150px;"
                                class="mb-10"
                                size="mini"
                                :disabled="selectedField? false : true"
                                prefix-icon="el-icon-search"
                                placeholder="Search data"
                                @keydown.native.enter="changeFilter"
                                clearable
                                v-model="filterInput">
                            </el-input>
                            <el-button-group class="mr-10 ml-10">
                                <el-button type="danger" size="mini" :loading="loadingReport" class="animated fadeInRight" @click="changeFilter">
                                    <i class="el-icon-search"/>
                                </el-button>
                                <el-button type="primary" size="mini" :loading="loadingExport" class="animated fadeInRight" @click="downloadExcel">
                                    <i class="mdi mdi-download"/>
                                </el-button>
                            </el-button-group>
                        </template>
                    </el-col>
                </el-row>
            </div>
            <br>
            <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <!-- <div>
                    <span>Send : </span><span>Delivered : </span><span>Read : </span>
                </div> -->
                <el-row class="mb-20" style="font-size:14px;">
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#249393; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            {{ formatNumber(totalMessages) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#57d952; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Success</span><br>
                            <el-tooltip v-if="selectedPhone" placement="right">
                                <div slot="content">Sent : 
                                    {{ formatNumber(status.sent+status.sending) }}
                                    <!-- <br/>Sending : {{ formatNumber(parseInt(status.sending)) }} -->
                                    <br/>Delivered : {{ formatNumber(parseInt(status.delivered)) }}
                                    <br/>Read : {{ formatNumber(parseInt(status.read)) }}</div>
                                <span style="font-size:16px;">
                                    <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                                    {{ formatNumber(parseInt(status.sent) + parseInt(status.sending) + parseInt(status.delivered) + parseInt(status.read)) }}
                                </span> 
                            </el-tooltip>
                            
                            <!-- <span style="font-size:22px;" v-else><i class="mdi mdi-check-all fl-l"></i> -</span> -->
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#e62e1a; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Failed</span> <br>
                            <el-tooltip v-if="selectedPhone" placement="right">
                                <div slot="content">Failed : {{ formatNumber(parseInt(status.failed)) }}
                                    <br/>Invalid : {{ formatNumber(parseInt(status.invalid)) }}</div>
                                <span style="font-size:16px;" v-if="selectedPhone">
                                    {{ formatNumber(parseInt(status.failed) + 
                                    parseInt(status.invalid) ) }}
                                </span>
                                <span style="font-size:14px;" v-else>-</span>
                            </el-tooltip>
                            <span style="font-size:16px;" v-else><!-- <i class="mdi mdi-check-all fl-l"></i>  -->-</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#ff9933; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Sent</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-check fl-l"></i>  -->
                            {{ formatNumber(status.sent+status.sending) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="3" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#0078ba; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">Delivered</span>
                            <br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                            {{ formatNumber(status.delivered) }}</span>
                            <!-- <span style="font-size:22px;" v-if="selectedPhone"><i class="mdi mdi-message-text-outline fl-l"></i> {{ formatNumber(status.read) }}</span> -->
                            
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#480911; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Read</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-check-all fl-l" style="color: #249393; font-weight:bold;"></i>  -->
                            {{ formatNumber(status.read+status.deleted) }}</span>
                            
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <!-- <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#bf0040; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Deleted</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                            {{ formatNumber(status.deleted) }}</span>
                            
                            <span style="font-size:16px;" v-else>
                            -</span>
                        </el-card>
                    </el-col> -->
                    <!-- <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#249393; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">BM Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                            {{ formatNumber(fbbmStatus.sent + fbbmStatus.delivered) }}</span>
                            <span style="font-size:16px;" v-else>
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#ff9933; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">BM Sent</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                            {{ formatNumber(fbbmStatus.sent) }}</span>
                            <span style="font-size:16px;" v-else>
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="3" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#0078ba; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">BM Delivered</span>
                            <br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                            {{ formatNumber(fbbmStatus.delivered) }}</span>                            
                            <span style="font-size:16px;" v-else>
                            -</span>
                        </el-card>
                    </el-col> -->
                </el-row>
                <el-row style="font-size:14px;">
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#37BEA6; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">BI-Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            {{ formatNumber(parseInt(usage.bi)) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#3EC9C9; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">CBP-Total</span><br>
                            <el-tooltip v-if="selectedPhone" placement="right">
                                <div slot="content">BI : 
                                    {{ formatNumber(parseInt(usage.cbp.bi)) }}
                                    <!-- <br/>Sending : {{ formatNumber(parseInt(status.sending)) }} -->
                                    <br/>UI : {{ formatNumber(parseInt(usage.cbp.ui)) }}</div>
                                <span style="font-size:16px;">
                                    <!-- <i class="mdi mdi-check-all fl-l"></i>  -->
                                    {{ formatNumber(parseInt(usage.cbp.total)) }}
                                </span> 
                            </el-tooltip>
                            
                            <!-- <span style="font-size:22px;" v-else><i class="mdi mdi-check-all fl-l"></i> -</span> -->
                        </el-card>
                    </el-col>
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#249393; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">UI-Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            {{ formatNumber(parseInt(usage.ui)) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#37BEA6; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">INT BI-Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            {{ formatNumber(parseInt(usage.int_bi)) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :xl="4" :lg="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable">
                        <el-card style="background-color:#249393; font-size:12px; color:#ffffff; font-weight:bold;" class="mb-10">
                            <span style="font-size:14px;">INT UI-Total</span><br>
                            <span style="font-size:16px;" v-if="selectedPhone">
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            {{ formatNumber(parseInt(usage.int_ui)) }}</span>
                            <span style="font-size:16px;" v-else>
                                <!-- <i class="mdi mdi-message-text-outline fl-l"></i>  -->
                            -</span>
                        </el-card>
                    </el-col>
                    <el-col :span="4" :md="4" :sm="4" :xs="4" justify="end" v-loading="loadingReportTable" >
                        <el-card style="background-color:#7f7cf3; color:#ffffff; font-weight:bold; font-size:12px;" class="mb-10">
                            <span style="font-size:14px;">Referral</span> <br>
                            <el-tooltip v-if="selectedPhone" placement="right">
                                <div slot="content">
                                    CBP : {{ formatNumber(parseInt(usage.ctwa_cbp || 0 ))  }}
                                    <br/>UI : {{ formatNumber(parseInt(usage.ctwa_ui || 0))}}
                                    <br/>INTERNATIONAL : {{ formatNumber(parseInt(usage.ctwa_international || 0))}}
                                </div>
                                <span style="font-size:16px;" v-if="selectedPhone">
                                    {{ formatNumber(parseInt(usage.ctwa_total || 0))}}
                                </span>
                                <span style="font-size:14px;" v-else>-</span>
                            </el-tooltip>
                            <span style="font-size:16px;" v-else><!-- <i class="mdi mdi-check-all fl-l"></i>  -->-</span>
                        </el-card>
                    </el-col>
                </el-row>
                <el-card shadow="card-shadow--small">
                    <el-pagination
                        background
                        prev-text="Prev"
                        next-text="Next"
                        layout="prev, pager, next"
                        :page-size="50"
                        @current-change="paginateReport"
                        :current-page="currentPage"
                        :total="totalMessages">
                    </el-pagination><br>
                    <div class="group-list scrollable only-y">
                        <template>
                            <el-table :data="dataMessages" style="width: 100%; color: #000 !important" v-loading="loadingReportTable" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)">
                                <el-table-column prop="dateTime" label="Date" width="150">
                                    <template slot-scope="props">
                                        {{ formatDate(props.row.created_date, "DD/MM/YY, HH:mm") }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="sender" :width="150" label="From"></el-table-column>
                                <el-table-column prop="to" :width="150" label="To"></el-table-column>
                                <el-table-column prop="type" :width="200" label="Type"></el-table-column>
                                <el-table-column prop="msg_id" :width="300" label="Message ID">
                                    <template slot-scope="props">
                                        {{ !props.row.msg_id || props.row.msg_id == 'null' ?  '-' : props.row.msg_id}}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="status" label="Status" align="center">
									<template slot-scope="props">
										<p v-if="props.row.status == 'processing'">
											<el-tooltip class="item" effect="dark" content="On process" placement="top">
												<span class="mdi mdi-clock"></span>
											</el-tooltip>
										</p>
										<p v-else-if="props.row.status == 'sent' || props.row.status =='sending'">
											<el-tooltip class="item" effect="dark" content="Message was sent" placement="top">
												<span class="mdi mdi-check"></span>
											</el-tooltip>
										</p>
										<p v-else-if="props.row.status == 'delivered'">
											<el-tooltip class="item" effect="dark" content="Message was delivered" placement="top">
												<span class="mdi mdi-check-all"></span>
											</el-tooltip>
										</p>
										<p v-else-if="props.row.status == 'read'">
											<el-tooltip class="item" effect="dark" content="Message was read" placement="top">
												<span style="color: #249393; font-weight:bold;" class="mdi mdi-check-all"></span>
											</el-tooltip>
										</p>
										<p v-else-if="props.row.status == 'fail' || props.row.status == 'failed'">
											<el-tooltip class="item" effect="dark" placement="top">
                                                <div style="max-width: 250px; overflow: hidden; width: auto;" class="tooltip" slot="content">{{'Failed. ' + (props.row.latest_error_message == null?'':props.row.latest_error_message)}}</div>
												<span style="color: red; font-weight:bold;" class="mdi mdi-close-circle-outline"></span>
											</el-tooltip>
										</p>
                                        <p v-else-if="props.row.status == 'invalid'">
											<el-tooltip class="item" effect="dark" placement="top">
                                                <div style="max-width: 250px; overflow: hidden; width: auto;" class="tooltip" slot="content">Invalid</div>
												<span style="color: red; font-weight:bold;" class="mdi mdi-close-circle-outline"></span>
											</el-tooltip>
										</p>
                                        <p v-else-if="props.row.status == 'deleted'">
											<el-tooltip class="item" effect="dark" placement="top">
                                                <div style="max-width: 250px; overflow: hidden; width: auto;" class="tooltip" slot="content">Deleted</div>
												<span style="color: red; font-weight:bold;" class="mdi mdi-close-circle-outline"></span>
											</el-tooltip>
										</p>
										<p v-else>
											<el-tooltip class="item" effect="dark" content="Failed" placement="top">
												<span style="color: red; font-weight:bold;" class="mdi mdi-close-circle-outline"></span>
											</el-tooltip>
										</p>
									</template>
								</el-table-column>
                                <el-table-column prop="latest_status_dt" :width="200" label="Update Status Date">
                                    <template slot-scope="props">
                                        {{ formatDate(props.row.latest_status_dt, "DD/MM/YY, HH:mm") }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dkd_pricing_category" :width="200" label="Pricing Category">
                                    <template slot-scope="props">
                                        <span v-if="props.row.dkd_pricing_category==2 && props.row.dkd_quota_type!=3 && props.row.dkd_quota_type != 4">
                                            BI
                                        </span>
                                        <span v-else-if="props.row.dkd_pricing_category==1 && props.row.dkd_quota_type!=3 && props.row.dkd_quota_type != 4">
                                            UI
                                        </span>
                                        <span v-else-if="props.row.dkd_pricing_category==3 && props.row.dkd_quota_type!=3">
                                            Referral
                                        </span>
                                        <span v-else-if="props.row.dkd_quota_type==3">
                                            CBP
                                        </span>
                                        <span v-else-if="props.row.dkd_pricing_category==2 && props.row.dkd_quota_type == 4">
                                            INT-BI
                                        </span>
                                        <span v-else-if="props.row.dkd_pricing_category==1 && props.row.dkd_quota_type == 4">
                                            INT-UI
                                        </span>                                
                                        <span v-else>
                                            -
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dkd_is_session" :width="200" label="Session Status">
                                    <template slot-scope="props">
                                        <span v-if="props.row.dkd_is_session==true && props.row.dkd_pricing_category!=3">
                                            Charge
                                        </span>
                                        <span v-else>
                                            Not Charge
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="to" label="#" width="100">
                                    <template slot-scope="props">
                                        <el-button title="Inquiry Check Whatsapp Contact" icon="el-icon-search" :loading="loadingBtnInq" @click="inquiryCheckNumber(props.row.to)" size="mini"/>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div><br/>
                    <el-pagination
                        background
                        prev-text="Prev"
                        next-text="Next"
                        layout="prev, pager, next"
                        :page-size="50"
                        @current-change="paginateReport"
                        :current-page="currentPage"
                        :total="totalMessages">
                    </el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-else></el-alert>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')
export default {
    name: 'Report',
    props: {
        dateRange: {
            type: Array
        },
        messages: {
            type: Array
        },
        loadingReport: {
            type: Boolean
        },
        showAlert: {
            type: Boolean
        },
        total: {
            type : Array
        },
        bmStatus: {
            type: Object
        },
        sender: {
            type: Array
        },
        filter: {
            type: String
        },
        statusMessage: {
            type: Object,
            required: false
        },
        statusUsage: {
            type: Object,
            required: false
        },
        dataReport: {
            type: Object
        }
    },
    data() {
        return {
            loadingBtnInq: false,
            // asyncComponent: 'peity',
            selectedStartDate: [
                moment().subtract(1,"day").format("YYYY-MM-DD"),
                moment().format("YYYY-MM-DD")
            ],
            searchStartDate: [
                moment().subtract(1,"day").hours(0).minutes(0).seconds(0).format(),
                moment().hours(0).minutes(0).seconds(0).format()
            ],
            selectedFilter: 'created_at',
            searchNumber: '',
            searchField: '',
            searchTerm: '',
            // selectedEndDate: '',
            filterInput: '',
            number:[],
            currentPage: 1,
            loadingReportTable: false,
            filterBy: [
                { value: "created_at", label: "Created At" },
                { value: "delivered_at", label: "Delivered At" },
            ],
            searchFields: [
                { value: "to", label: "Recipient" },
                { value: "msg_id", label: "Message ID" },
                { value: "type", label: "Template Name" }
            ],
            messageTypeField: [
                { value: "", label: "All" },
                { value: "hsm", label: "Notification" },
                { value: "interactive", label: "Interactive" }
            ],
            sessionTypeField: [
                { value: "all", label: "All" },
                { value: "charge", label: "Charge" },
                { value: "not_charge", label: "Not Charge" },
            ],
            selectedMessageTypeField: "",
            selectedSessionTypeField: "all",
            /* options: [
                {
                    value: '1',
                    label: 'Januari'
                }, {
                    value: '2',
                    label: 'Februari'
                }, {
                    value: '3',
                    label: 'Maret'
                }, {
                    value: '4',
                    label: 'April'
                }, {
                    value: '5',
                    label: 'Mei'
                }, {
                    value: '6',
                    label: 'Juni'
                }, {
                    value: '7',
                    label: 'Juli'
                }, {
                    value: '8',
                    label: 'Agustus'
                }, {
                    value: '9',
                    label: 'September'
                }, {
                    value: '10',
                    label: 'Oktober'
                }, {
                    value: '11',
                    label: 'November'
                }, {
                    value: '12',
                    label: 'Desember'
                }
            ], */
            //optionsYear: [],
            loadingExport: false,
            selectedYear: moment().format("YYYY"),
            //selectedMonth: moment().format("M"),
            selectedPhone: '',
            selectedField: 'to',
            dataMessages: [],
            totalMessages: 0,
            fbbmStatus: {
                sent: 0,
                delivered: 0
            },
            status: {
                read:0,
                sent:0,
                failed:0,
                delivered:0,
                invalid: 0,
            },
            usage: this.statusUsage,
            listReport: this.dataReport
        }
    },
    methods: {
        formatDate(val, format){
            return moment(val).local().format(format)
        },
        formatNumber(value) {
			// let val = (value/1).toFixed(2).replace('.', ',')
			return value.toLocaleString('id-ID')
		},
        async paginateReport(page) {
            this.currentPage = page
            await this.loadReport(this.currentPage, null, { search_by: this.searchField, search: this.searchTerm })
        },
        async downloadExcel(){
            this.loadingExport = true
            await this.loadReport(1, 'download', { search_by: this.searchField, search: this.searchTerm })
            this.loadingExport = false
        },
        changeFilter() {
            this.currentPage = 1
            this.searchStartDate = this.selectedStartDate.slice()
            this.searchNumber = this.selectedPhone
            this.searchField = this.selectedField
            this.searchTerm = this.filterInput
			this.loadReport(this.currentPage, null, { search_by: this.searchField, search: this.searchTerm })
		},
        async loadReport(page = 1, query, { search_by = this.selectedField, search = undefined }){
            if(query == "download") {
				let action = ""
				await this.$confirm(`You will request notification report for this company.<br/><b>You may not request any report for this company until this process is finish.</b> Continue request report?`, 'Confirm', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					dangerouslyUseHTMLString: true,
					type: 'warning',
					center: true
				}).then(() => {
				}).catch(() => {
					action = "cancel"
				});
				if(action == "cancel") return
            }
            
            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "user/"+custId+"/report/notification?page="+page,
                method: 'post',
                data:{
					"year":this.selectedYear.toString(),
                    "startDate":moment(this.searchStartDate[0]).format("YYYY-MM-DD"),
                    "endDate":moment(this.searchStartDate[1]).format("YYYY-MM-DD"),
                    "number":this.searchNumber,
                    search_by: search_by,
                    search: search
                },
                params: {
                    page: page,
                    type: this.selectedMessageTypeField,
                    filter_by: this.selectedFilter
                }
            }

            if (query == "download") {
				apiOptions.url = config.baseApi + `user/${custId}/report/notification/download`
                apiOptions.method = "get"
                apiOptions.params = apiOptions.data
                apiOptions.params.type = this.selectedMessageTypeField
                apiOptions.params.filter_by = this.selectedFilter
                delete apiOptions.data
            }

            await api(apiOptions)
            .then(res => {
                if(query == "download"){
                    // console.log(res.headers['content-type'].indexOf('application/json'))
                    if(res.data.ec == 200){
                        this.$swal(this.$t('success'), "We will process your request. Please wait for a while. Thank you!", "success")
                    } else {
                        if(res.data.message == "waiting"){
                            this.$swal(this.$t('warning'), "You may not request any report for this company until last request was finished", "warning")
                        } else {
                            this.$swal(this.$t('error'), this.$t('error_text'), "error")
                        }
                    }
                } else{
                    // var dt
                    if(res.data.ec == 200){
                        // this.resData = res.data.data
                        this.dataMessages = res.data.data.messages
                        // this.dataMessages = _.orderBy(this.dataMessages, function(o) { return new moment(o.dateTimeIso); }, ['desc'])
                        // this.month = res.data.data.month
                        this.totalMessages = parseInt(res.data.data.total)
                        this.status = res.data.data.status
                        this.fbbmStatus = res.data.data.fbbm ? res.data.data.fbbm : {
                            sent: 0,
                            delivered: 0
                        }

                        let usage =  res.data.data.usage || null

                        if (usage) {
                            this.usage.cbp.total = (usage.national.cbp.bi || 0) + (usage.national.cbp.ui || 0)
                            this.usage.cbp.bi = usage.national.cbp.bi || 0
                            this.usage.cbp.ui = usage.national.cbp.ui || 0
                            this.usage.bi = (usage.national.bi || 0)
                            this.usage.ui = (usage.national.ui || 0)
                            this.usage.int_bi = (usage.international.bi || 0)
                            this.usage.int_ui = (usage.international.ui || 0)
                            this.usage.ctwa_total = (usage.ctwa.total || 0)
                            this.usage.ctwa_ui = (usage.ctwa.ui || 0)
                            this.usage.ctwa_bi = (usage.ctwa.bi || 0)
                            this.usage.ctwa_cbp = (usage.ctwa.cbp || 0)
                            this.usage.ctwa_international = (usage.ctwa.international || 0)
                        }
                        // this.status.processing = res.data.data.status.processing
                        // this.status.success = res.data.data.status.sent
                        // this.status.failed = res.data.data.status.failed
                        // console.log("DATA PROC",this.status.success)
                    }
                    // dt = this.resData
                }
            })
            .catch(error => {
				this.$swal(this.$t('error'), error.message, "error")
            })
            this.loadingReportTable = false
        },
        async inquiryCheckNumber(number){
            this.loadingBtnInq = true
            await api({
                method: "post",
                url: "whatsapp/inquiryNumber",
                data: {
                    number: number.charAt(0) == "+" ? number : "+" + number,
                    sender: this.selectedPhone,
                    customer_id: this.$route.params.consumen
                }
            }).then(resp => {
                let status =
                    resp &&
                    resp.data &&
                    resp.data.ec
                        ? resp.data.ec
                        : null;
                let message =
                    resp &&
                    resp.data &&
                    resp.data.message
                        ? resp.data.message
                        : this.$t('error_text');

                if (status === 200) {
                    if(resp.data.data[0].status.toLowerCase() == "valid"){
                        this.$swal("Valid", `${number} is a valid Whatsapp number.`, "success")
                    } else {
                        this.$swal("Oops", `${number} is an invalid Whatsapp number.`, "warning")
                    }
                } else {
                    this.$swal(this.$t('error'), message, "error")
                }
            }).catch(err => {
                console.log(err)
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
            })
            this.loadingBtnInq = false            
        }
    },
    watch: {
        dateRange: function() {
            this.selectedStartDate = this.dateRange
        },
        sender: function() {
            this.number = this.sender
            this.selectedPhone = this.number[0]
            this.searchNumber = this.selectedPhone            
        },
        statusMessage: function(){
            this.status = this.statusMessage
        },
        statusUsage: function(){
            this.usage = this.statusUsage
        },
        total: function() {
            this.totalMessages = this.total[0]
        },
        bmStatus: function() {
            this.fbbmStatus = this.bmStatus
        },
        messages: function(){
            this.dataMessages = this.messages
            this.currentPage = 1
            this.selectedField = 'to'
            this.filterInput = ''
        },
        filter: function() {
            this.selectedFilter = this.filter           
        }
    }
}
</script>
